module.exports = __webpack_public_path__ + "static/14-sykurbad-39f2859ae5504f20c41471206710f23b.jpg";